import * as React from 'react';
import type { SVGProps } from 'react';

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M11.99 1.94 2 11.92l9.98 9.98 2.12-2.12-6.3-6.3H22v-3H7.7l6.4-6.42L12 1.94z" />
  </svg>
);
export default SvgArrowLeft;
